import * as React from "react";
import clsx from "clsx";
import { UseFormRegister, FieldErrors } from "react-hook-form";
import { StyledText } from "../../../assets/typography/typography";
import { colors } from "../../../components/colors";

interface OwnProps {
  name: string;
  label?: string;
  helpText?: string;
  register: UseFormRegister<any>;
  errors: FieldErrors<any>;
  type?: string;
  children?: React.ReactNode;
  include?: (
    | "all"
    | "generic"
    | "production_addition"
    | "delivery"
    | "delivery_buffer"
  )[];
}

export const CheckboxGroupInventoryItemClassificationFormField: React.FC<OwnProps> = ({
  include = ["all"],
  ...props
}) => {
  const errors = props.errors;
  const hasError = !!errors?.[props.name];
  const errorMessage = errors?.[props.name]?.message as string;

  const values = React.useMemo(() => {
    return [
      ...(include.includes("all") || include.includes("generic")
        ? [
            {
              label:
                "Voucher created from this voucher template, will work for all regular products",
              value: "generic",
            },
          ]
        : []),
      ...(include.includes("all") || include.includes("production_addition")
        ? [
            {
              label:
                "Voucher created from this voucher template, will work for all product additions",
              value: "production_addition",
            },
          ]
        : []),
      ...(include.includes("all") || include.includes("delivery")
        ? [
            {
              label:
                "Voucher created from this voucher template, will work for delivery fee",
              value: "delivery",
            },
          ]
        : []),
      ...(include.includes("all") || include.includes("delivery_buffer")
        ? [
            {
              label:
                'Voucher created from this voucher template, will work for "Fee for small order"',
              value: "delivery_buffer",
            },
          ]
        : []),
    ];
  }, [include]);

  return (
    <div className={clsx("form-group", { "has-error": hasError })}>
      {props.label && (
        <StyledText
          color={colors.textPrimary}
          className="bodySubtextSemibold mb-2"
        >
          {props.label}
        </StyledText>
      )}
      <div className="custom-controls-stacked">
        {values.map((v) => (
          <label key={v.value} className="custom-control custom-checkbox">
            <input
              type="checkbox"
              className="custom-control-input"
              {...props.register(`${props.name}` as const)}
              value={v.value}
            />
            <span className="custom-control-label">{v.label}</span>
          </label>
        ))}
      </div>
      {hasError && (
        <StyledText
          color={colors.errorDark}
          className="bodySubtextRegular mt-2"
        >
          {errorMessage}
        </StyledText>
      )}
      {props.helpText && (
        <StyledText
          color={colors.textSecondary}
          className="bodySubtextRegular mt-2"
        >
          {props.helpText}
        </StyledText>
      )}

      {props.children && <>{props.children}</>}
    </div>
  );
};
